import Link from 'next/link';
import { chainflipLinks } from '@chainflip/utils/consts';
import Message from '@/shared/components/molecules/Message';
import useLocalStorage from '@/shared/hooks/useLocalStorage';
import { usePolkadot } from '@/shared/hooks/usePolkadot';

export const Banners = ({ isMobileView = false }: { isMobileView?: boolean }) => {
  const { selectedAccount, selectAccount } = usePolkadot();
  const [displayMessage, setDisplayMessage] = useLocalStorage(
    'displayBoostSplitMessage',
    (value) => (typeof value === 'boolean' ? value : true),
  );

  return (
    <>
      {isMobileView ? (
        <div className="flex w-full items-center justify-center bg-cf-blue-1/20 p-[5px] font-aeonikMedium text-14 text-cf-blue-2">
          You are in view-only mode.
        </div>
      ) : (
        selectedAccount?.readonly && (
          <div className="flex w-full items-center justify-center bg-cf-pink-1/20 p-2 text-14 text-cf-pink-1">
            You are in view-only mode.&nbsp;
            <button type="button" className="underline" onClick={() => selectAccount(null)}>
              Sign up now
            </button>
            &nbsp;to start earning fees!
          </div>
        )
      )}
      {!selectedAccount?.readonly && displayMessage && (
        <Message
          message={
            <span>
              {`We've included Boost into our $FLIP burning mechanism by charging a network fee. Read more about why`}{' '}
              <Link
                className="underline"
                target="_blank"
                href={new URL(
                  '/boost-fee-split-flip-burn-increase',
                  chainflipLinks.blog,
                ).toString()}
              >
                here
              </Link>
            </span>
          }
          variant="success"
          onClose={() => setDisplayMessage(false)}
        />
      )}
    </>
  );
};
